import axios from 'axios'

export default {
    get: () => axios.get('brands'),
    getFiltered: (data) => axios.post('brands', data),
    store: (data) => axios.post('brands/store', data),
    update: (data) => axios.post('brands/update', data),
    delete: (id) => axios.post('brands/delete', id)
}